import { render, staticRenderFns } from "./list-controls.vue?vue&type=template&id=23ecc84b"
import script from "./list-controls.vue?vue&type=script&lang=js"
export * from "./list-controls.vue?vue&type=script&lang=js"
import style0 from "./list-controls.vue?vue&type=style&index=0&id=23ecc84b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports